import { useContext } from 'react';
import { FeedbackContext } from '../contexts/FeedbackContext';

export const useFeedback = () => {
  const { feedback, setFeedback } = useContext(FeedbackContext);

  return [feedback, setFeedback];
};
export default useFeedback;
